module.exports = __webpack_public_path__ + "6d1c78c2bdde382498bd504567fda21a.pdf";